<template>
  <div id="main">
    <div class="video-container">
      <video class="video" ref="myVideo" @click="playVideo"
             src="//download.wrightin.com/train_prepare_video/wrightin-home-l30.mp4"
             muted autoplay loop
             poster="//download.wrightin.com/train_prepare_video/wrightin-home-l30.mp4?x-oss-process=video/snapshot,t_0,f_jpg,m_fast"
             @contextmenu.prevent
             playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"
             @pause="playState(false)" @play="playState(true)">
      </video>
      <img v-if="!isVideoPlaying" class="playBtn" @click.stop="playVideo"
           :src='require("@/assets/img/product/t20/play_circle.png")' />
      <div class="copyright">广告审查批准文号:苏械广审(视)第270509-06477号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="product-show">
      <div class="title">
        <p>Lumina耀雅·盆底康复治疗仪</p>
        <p>对症修复盆底肌<br/>焕活私密紧弹润</p>
      </div>
      <img v-lazy="require('@/assets/img/product/l30/product-show.png')">
      <div class="bottom-gradient"></div>
      <div class="img-copyright">广告审查批准文号:苏械广审(文)第270509-06971号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="l30-probe">
      <div class="video-container">
        <video src="//download.wrightin.com/train_prepare_video/mobile-wrightin-probe.mp4"
               poster="//download.wrightin.com/train_prepare_video/mobile-wrightin-probe.mp4?x-oss-process=video/snapshot,t_0,f_jpg,m_fast"
               @contextmenu.prevent
               autoplay muted loop playsinline preload="auto"
               x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true">

        </video>
      </div>
      <div class="title">
        <p>专为亚洲女性研发的</p>
        <p>零感自适应探头</p>
      </div>
      <div class="bottom-gradient"></div>
      <div class="img-copyright">广告审查批准文号:苏械广审(视)第270509-08230号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>
        请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司
      </div>
    </div>
    <div class="product-advantage">
      <div id="videoSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(videoItem, videoIndex) in videoList" :key="videoIndex">
            <div class="img-container">
              <video :src="videoItem.path"
                     :poster="videoItem.path + '?x-oss-process=video/snapshot,t_0,f_jpg,m_fast'"
                     muted autoplay loop @contextmenu.prevent
                     playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true"
                     x5-playsinline="true">
              </video>
            </div>
            <div class="desc">
              <p v-html="videoItem.title"></p>
              <p v-html="videoItem.desc"></p>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="swiper-copyright">广告审查批准文号:苏械广审(文)第270509-05585号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>

    <div class="product-function">
      <div id="bannerSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(functionItem, functionIndex) in functionList" :key="functionIndex">
            <div class="img-container">
              <img :src="functionItem.path" alt="" />
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="swiper-copyright">广告审查批准文号:苏械广审(文)第270509-04692号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>

    <div class="product-standard">
      <div class="desc">
        <p>下一代盆底康复治疗仪·专注提升「盆底肌」</p>
        <p>肌电压力双重评估</p>
        <p>科学强健盆底肌</p>
      </div>
      <div id="standardSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(standardItem, standardIndex) in standardList" :key="standardIndex">
            <div class="img-container">
              <img :src="standardItem.path" alt="" />
            </div>
            <div class="title" v-html="standardItem.title"></div>
            <div class="words" v-html="standardItem.words"></div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>

    <div class="product-rejuvenation">
      <div class="title">
        <p>下一代盆底康复治疗仪·「私密抗衰」</p>
        <p>科学修护内外阴</p>
        <p>多维度私密抗衰</p>
      </div>
      <video src="//download.wrightin.com/train_prepare_video/mobile-wrightin-l30-rejuvenation.mp4"
             @contextmenu.prevent
             autoplay muted loop playsinline preload="auto"
             x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true">
      </video>
      <div class="img-copyright">广告审查批准文号:苏械广审(文)第270509-05578号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>

    <div class="repair-improve">
      <div class="title">
        <p>三层立体奢护</p>
        <p>专项修复提升</p>
      </div>
      <img v-lazy="require('@/assets/img/product/l30/repair-improve.png')">
    </div>

    <div class="vagina-improve">
      <div class="title">
        <p>四维内阴提升</p>
        <p>构筑私密健康</p>
      </div>
      <div class="four-intravaginal-list">
        <div v-for="item in fourIntravaginalList" class="intravaginal-item">
          <video :src="item.path" muted autoplay loop preload="auto"
                 @contextmenu.prevent
                 playsinline="true" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"/>
          <div class="title" v-html="item.title"></div>
        </div>
      </div>
      <div class="swiper-copyright">
        广告审查批准文号：苏械广审(文)第270509-05579号<br/>
        盆底康复治疗仪  医疗器械注册证编号:苏械注准 20262090138<br/>
        请仔细阅读产品说明书或者在医务人员的指导下购买和使用
        禁忌内容或者注意事项详见说明书<br/>
        南京麦豆健康科技有限公司
      </div>
    </div>

    <div class="vulva-repair">
      <div class="title">
        <p>双重外阴修复</p>
        <p>打造专属私密健康方案</p>
        <p>外阴电极片联合协同刺激，增强外阴闭合能力</p>
      </div>
      <img v-lazy="require('@/assets/img/product/l30/vulva-repair.png')">
      <video src="//download.wrightin.com/train_prepare_video/mobile-wrightin-l30-vulva-repair.mp4" muted autoplay loop preload="auto"
             @contextmenu.prevent
             playsinline="true" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"/>
      <div class="img-copyright">
        广告审查批准文号:苏械广审(视)第270509-05604号<br/>
        盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>
        请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>
        南京麦豆健康科技有限公司
      </div>
    </div>

    <div class="soothing-massage">
      <div class="title">
        <p>舒缓按摩 肌肉放松</p>
        <p>缓解多种亲密困扰</p>
        <p>缓解亲密痛疼，提高女性私密健康功能</p>
      </div>
      <div class="video-container">
        <video src="//download.wrightin.com/train_prepare_video/mobile-wrightin-soothing-massage.mp4" muted autoplay loop preload="auto"
               @contextmenu.prevent
               playsinline="true" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"/>
      </div>
      <div class="img-copyright">
        广告审查批准文号:苏械广审(视)第270509-05580号<br/>
        盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>
        请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>
        南京麦豆健康科技有限公司
      </div>
    </div>

    <div class="diastasis-recti">
      <img v-lazy="require('@/assets/img/product/l30/diastasis-recti.png')">
      <div class="about">
        <p>下一代盆底康复治疗仪·多方面「塑形养护」</p>
        <p>多维科技系统</p>
        <p>修复腹直肌分离</p>
      </div>
      <div class="img-copyright">
        广告审查批准文号：苏械广审(文)第270509-05584号<br/>
        盆底康复治疗仪  医疗器械注册证编号:苏械注准 20262090138<br/>
        请仔细阅读产品说明书或者在医务人员的指导下购买和使用
        禁忌内容或者注意事项详见说明书<br/>
        南京麦豆健康科技有限公司
      </div>
    </div>

    <div class="electrode-pad">
      <img v-lazy="require('@/assets/img/product/l30/electrode-pad.png')">
      <div class="about">
        <p>0.5-10000Hz超宽频脉冲</p>
        <p>多方位科学塑形</p>
        <p>配置多功能电极片</p>
        <p>五大核心波形技术，智能匹配不同需求</p>
      </div>
      <div class="img-copyright">
        广告审查批准文号：苏械广审(文)第270509-04694号<br/>
        盆底康复治疗仪  医疗器械注册证编号:苏械注准 20262090138<br/>
        请仔细阅读产品说明书或者在医务人员的指导下购买和使用
        禁忌内容或者注意事项详见说明书<br/>
        南京麦豆健康科技有限公司
      </div>
    </div>

    <div class="product-science">
      <div id="scienceSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(scienceItem, scienceIndex) in scienceList" :key="scienceIndex">
            <div class="img-container">
              <img :src="scienceItem.path" alt="" />
            </div>
            <div class="title" v-html="scienceItem.title"></div>
            <div class="words" v-html="scienceItem.words"></div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>

    <div class="research">
      <img v-lazy="require('@/assets/img/product/l30/research.png')">
      <div class="about">
        <p>国际权威验证</p>
        <p>盆底治疗效果提升</p>
        <p>《生殖医学杂志》文献发表</p>
      </div>
    </div>

    <div class="zhuanli">
      <img v-lazy="require('@/assets/img/product/l30/zhuanli.png')">
      <div class="about">
        <p>34大专利权威认证</p>
      </div>
    </div>

    <div class="medical-zhuanli">
      <img v-lazy="require('@/assets/img/product/l30/medical-zhuanli.png')">
      <div class="about">
        <p>医疗器械认证及专利</p>
        <p>严苛品质</p>
      </div>
    </div>

  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
  data() {
    return {
      showCopyright: true,
      showCopyrightTimer: null,
      rem: document.documentElement.style.fontSize.replace("px", "") * 1,
      isVideoPlaying: false,
      isVideoPlayingPattern: false,
      videoSwiper: null,
      bannerSwiper: null,
      standardSwiper: null,
      scienceSwiper: null,
      videoList: [
        {
          path: "//download.wrightin.com/train_prepare_video/wrightin-product-l30-1.mp4",
          title: "更贴心",
          desc: "医用级硅胶",
        },
        {
          path: "//download.wrightin.com/train_prepare_video/wrightin-product-l30-2.mp4",
          title: "更多维",
          desc: "三维盆底智能评估系统",
        },
        {
          path: "//download.wrightin.com/train_prepare_video/wrightin-product-l30-3.mp4",
          title: "更智能",
          desc: "CES离心电刺激* 舒缓按摩，肌肉放松 智能抗阻凯格尔训练",
        },
        {
          path: "//download.wrightin.com/train_prepare_video/wrightin-product-l30-4.mp4",
          title: "更科学",
          desc: "智能变频脉冲 WTR*智能训练",
        }
      ],
      functionList: [
        {
          path: require("@/assets/img/product/l30/func-1.png")
        },
        {
          path: require("@/assets/img/product/l30/func-2.png")
        },
        {
          path: require("@/assets/img/product/l30/func-3.png")
        }
      ],
      standardList: [
        {
          path: require("@/assets/img/product/l30/standard-1.png"),
          title: "国际标准Glazer模板<br/>6大维度35项指标科学评估",
          words: '广告审查批准文号:苏械广审(文)第270509-04693号 盆底康复治疗仪 医器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require("@/assets/img/product/l30/standard-2.png"),
          title: "大数据智能算法<br/>动态构建综合性解决方案",
          words: '广告审查批准文号:苏械广审(文)第270509-05605号 盆底康复治疗仪 医器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require("@/assets/img/product/l30/standard-3.png"),
          title: "十大训练模式<br/>辅助改善盆底状态",
          words: '广告审查批准文号:苏械广审(文)第270509-06469号 盆底康复治疗仪 医器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require("@/assets/img/product/l30/standard-4.png"),
          title: "盆底疲劳智能监测<br/>科学调整训练难度",
          words: '广告审查批准文号:苏械广审(文)第270509-05583号 盆底康复治疗仪 医器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require("@/assets/img/product/l30/standard-5.png"),
          title: "WTR科学训练流程<br/>改善盆底肌肉状态",
          words: '广告审查批准文号:苏械广审(文)第270509-06476号 盆底康复治疗仪 医器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
      ],
      fourIntravaginalList: [
        {
          path: '//download.wrightin.com/train_prepare_video/mobile-wrightin-l30-health-1.mp4',
          title: '私密紧致提升'
        },
        {
          path: '//download.wrightin.com/train_prepare_video/mobile-wrightin-l30-health-2.mp4',
          title: '私密敏感激活'
        },
        {
          path: '//download.wrightin.com/train_prepare_video/mobile-wrightin-l30-health-3.mp4',
          title: '私密水润如初'
        },
        {
          path: '//download.wrightin.com/train_prepare_video/mobile-wrightin-l30-health-4.mp4',
          title: '私密快感提升'
        }
      ],
      scienceList: [
        {
          path: require("@/assets/img/product/l30/science1.png"),
          title: "六重智能侦测系统<br/>层层把关 全程相伴",
        },
        {
          path: require("@/assets/img/product/l30/science2.png"),
          title: "个性化定制方案的澜渟APP<br/>丰富功能 一键训练",
          words: '广告审查批准文号:苏械广审(文)第270509-04695号 盆底康复治疗仪 医器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require("@/assets/img/product/l30/science3.png"),
          title: "悬浮智控主机<br/>30天超长续航",
        },
        {
          path: require("@/assets/img/product/l30/science4.png"),
          title: "多V1陪伴 终身护航<br/>GMAA认证医学顾问",
        }
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.showCopyrightTimer = setTimeout(() => {
      this.showCopyright = false;
      clearTimeout(this.showCopyrightTimer);
    }, 5000);
    setInterval(() => {
      this.pageScroll();
    }, 1000);
    this.videoSwiper = new Swiper("#videoSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
    this.bannerSwiper = new Swiper("#bannerSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
    this.standardSwiper = new Swiper("#standardSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000000,
        disableOnInteraction: false
      }
    });
    this.scienceSwiper = new Swiper("#scienceSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000000,
        disableOnInteraction: false
      }
    });

  },
  methods: {
    pageScroll() {
      // 判断 video是不是被 header sh
      const videoDom = document.querySelector(".video-container");
      const headerDom = document.querySelector("#top");
      if (videoDom && headerDom && this.$refs.myVideo) {
        // videoDom 在 屏幕中间
        if (videoDom.getBoundingClientRect().top + videoDom.getBoundingClientRect().height / 2 > headerDom.getBoundingClientRect().height &&
            window.innerHeight - videoDom.getBoundingClientRect().top > videoDom.getBoundingClientRect().height / 2) {
        } else {
          this.$refs.myVideo.pause();
          this.isVideoPlaying = false;
        }
      }
      const videoDomPattern = document.querySelector(".video-container-pattern");
      if (videoDomPattern && headerDom && this.$refs.myVideoPattern) {
        // videoDom 在 屏幕中间
        if (videoDomPattern.getBoundingClientRect().top + videoDomPattern.getBoundingClientRect().height / 2 > headerDom.getBoundingClientRect().height &&
            window.innerHeight - videoDomPattern.getBoundingClientRect().top > videoDomPattern.getBoundingClientRect().height / 2) {
        } else {
          this.$refs.myVideoPattern.pause();
          this.isVideoPlayingPattern = false;
        }
      }
    },
    playState(isPlay) {
      this.isVideoPlaying = isPlay;
      this.showCopyright = true;
      if (isPlay) {
        this.$refs.myVideo.setAttribute("controls", "true");
        this.showCopyrightTimer = setTimeout(() => {
          this.showCopyright = false;
          clearTimeout(this.showCopyrightTimer);
        }, 5000);
      } else {
        this.$refs.myVideo.removeAttribute("controls");
      }
    },
    playVideo() {
      this.$refs.myVideo.muted = false;
      this.$refs.myVideo.play();
    },
    playStatePattern(isPlay) {
      this.isVideoPlayingPattern = isPlay;
      if (isPlay) {
        this.$refs.myVideoPattern.setAttribute("controls", "true");
      } else {
        this.$refs.myVideoPattern.removeAttribute("controls");
      }
    },
    playVideoPattern() {
      this.$refs.myVideoPattern.muted = false;
      this.$refs.myVideoPattern.play();
    }
  }
};
</script>

<style lang="scss" scoped>
#main {
  background-color: #100622;
}

.video-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20.5rem;

  > .video {
    width: 100%;
    object-fit: cover;
    background-color: #100622;
  }

  > .playBtn {
    position: absolute;
    width: 4.4rem;
  }

  >.copyright {
      position: absolute;
      bottom: 1.2rem;
      left: 0;
      width: 100%;
      padding: 0 2%;
      font-weight: 400;
      font-size: 0.8rem;
      color: rgba(255, 255, 255, 0.6);
      line-height: 1.2rem;
      pointer-events: none;
  }
}

.product-show {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  > .title {
    position: absolute;
    top: 3.62rem;
    > p {
      font-weight: 500;
      font-size: 1.27rem;
      color: #FFFFFF;
      text-align: center;
    }
    > p:nth-child(2) {
      margin-top: 0.72rem;
      font-size: 1.99rem;
      /* 金色渐变：从浅金到深金 */
      background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
      /* 核心属性：将背景裁剪到文字区域 */
      background-clip: text;
      /* 文字透明，显示渐变背景 */
      color: transparent;
    }
  }

  > img {
    width: 100%;
    height: 100%;
  }
  > .bottom-gradient {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 5.43rem;
    background: linear-gradient(180deg, rgba(27,12,49,0) 0%, #02000A 100%);
  }
}

.l30-probe {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  align-items: center;

  > .video-container {
    overflow: hidden;
    position: relative;
    height: 34rem; /* 跟你原来的图片高度保持一致 */
    > video {
      background-color: #100622;
      width: 168%;
      object-fit: cover;
      z-index: 1;
    }
  }

  > .title {
    position: absolute;
    bottom: 6.5rem;
    z-index: 3;
    > p {
      display: flex;
      justify-content: center;
      line-height: 2.81rem;
      font-weight: 500;
      font-size: 1.99rem;
      color: #fff;
    }
    > p:nth-child(2) {
      /* 金色渐变：从浅金到深金 */
      background: linear-gradient(90deg, #D0B26B 0%, #E5C87F 25%, #F5D995 50%, #F9E2A8 100%);
      /* 核心属性：将背景裁剪到文字区域 */
      background-clip: text;
      /* 文字透明，显示渐变背景 */
      color: transparent;
    }
  }

  > .copyright {
    position: absolute;
    bottom: 1.2rem;
    left: 0;
    width: 100%;
    padding: 0 2%;
    font-weight: 400;
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.2rem;
    pointer-events: none;
    z-index: 2;
  }

  > .bottom-gradient {
    position: relative;
    bottom: 0;
    width: 100%;
    height: 6.8rem;
    background: linear-gradient(0deg, rgba(27,12,49,0) 0%, #170c2f 100%);
  }
}

.swiper-copyright {
  position: relative;
  bottom: 6rem;
  right: 1.2rem;
  width: 100%;
  font-weight: 400;
  font-size: .8rem;
  color: hsla(0, 0%, 100%, .6);
  line-height: 1.2rem;
  pointer-events: none;
  text-align: right;
  z-index: 2;
}

.product-advantage {
  height: 28.55rem;
  position: relative;
  overflow: hidden;
  background: linear-gradient( 360deg, #1B0C31 0%, #371C73 49.04%, #0F0527 100%);

  > #videoSwiper {
    height: 100%;
    position: relative;
    overflow: hidden;

    .swiper-slide {
      position: relative;
      display: flex;
      justify-content: center;

      > .img-container {
        padding: 0 1.54rem;
        > video {
          width: 100%;
          border-radius: 1.15rem;
        }
      }

      > .desc {
        position: absolute;
        bottom: 9.08rem;
        width: 34.5rem;
        height: 6.25rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.45) 100%);
        border-radius: 0rem 0rem 1.09rem 1.09rem;
        > p:nth-child(1) {
          font-size: 1.35rem;
          color: #fff;
          height: 1.92rem;
          text-align: center;
          margin-bottom: 0.38rem;
          margin-top: 1.15rem;
        }
        > p:nth-child(2) {
          width: 24.91rem;
          height: 1.54rem;
          font-size: 1.15rem;
          color: #fff;
          text-align: center;
        }
      }
    }

    .swiper-pagination {
      bottom: 6.2rem;
    }

    /deep/ .swiper-pagination-bullet {
      background: transparent;     /* 改成透明 = 空心 */
      border: 0.1rem solid #fff;    /* 白色边框 */
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #fff;             /* 选中 = 白色实心 */
      border: 0.1rem solid transparent;
    }
    .swiper-slide:nth-child(4) {
      > .desc {
        height: 7.25rem;
      }
    }
  }
}

.product-function {
  height: 82.37rem;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #100622;

  > #bannerSwiper {
    padding-top: 1.81rem;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;

    .swiper-slide {
      position: relative;

      > .img-container {
        width: 100%;
        padding: 0 1.54rem;
        > img {
          width: 100%;
        }
      }
    }

    .swiper-pagination {
      bottom: 6rem;
    }

    /deep/ .swiper-pagination-bullet {
      background: transparent;     /* 改成透明 = 空心 */
      border: 0.1rem solid #fff;    /* 白色边框 */
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #fff;             /* 选中 = 白色实心 */
      border: 0.1rem solid transparent;
    }
  }
}

.product-standard {
  height: 61.16rem;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #100622;
  display: flex;
  flex-direction: column;

  > .desc {
    position: relative;
    > p {
      display: flex;
      justify-content: center;
      line-height: 2.81rem;
      font-size: 1.99rem;
      color: #fff;
      font-weight: 500;
    }
    > p:nth-child(1) {
      line-height: 1.63rem;
      font-size: 1.25rem;
      color: rgba(255,255,255,0.65);
      padding-bottom: 0.91rem;
      padding-top: 3.62rem;
    }
    > p:nth-child(2) {
      /* 金色渐变：从浅金到深金 */
      background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
      /* 核心属性：将背景裁剪到文字区域 */
      background-clip: text;
      /* 文字透明，显示渐变背景 */
      color: transparent;
    }
  }

  > #standardSwiper {
    padding-top: 2.72rem;
    height: 100%;
    position: relative;
    overflow: hidden;

    .swiper-slide {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      > .img-container {
        padding: 0 1.54rem;
        width: 100%;
        > img {
          width: 100%;
        }
      }
      > .words {
        position: absolute;
        font-size: 0.8rem;
        color: rgba(255, 255, 255, 0.6);
        text-align: center;
        line-height: 0.9rem;
        bottom: 13rem;
        width: 80%;
      }
      > .title {
        margin: 0 1.54rem;
        position: absolute;
        width: 34.5rem;
        height: 9.3rem;
        bottom: 3.1rem;
        display: flex;
        justify-content: center;
        text-align: center;
        line-height: 2.02rem;
        font-size: 1.45rem;
        color: rgba(255,255,255,0.65);
        align-items: center;
        background: linear-gradient( 180deg, #3E2365 0%, #200F37 100%);
        border-radius: 0rem 0rem 1.09rem 1.09rem;
      }
    }

    .swiper-pagination {
      position: absolute;
      bottom: 0;
    }

    /deep/ .swiper-pagination-bullet {
      background: transparent;     /* 改成透明 = 空心 */
      border: 0.1rem solid #fff;    /* 白色边框 */
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #fff;             /* 选中 = 白色实心 */
      border: 0.1rem solid transparent;
    }
  }
}

.product-rejuvenation {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  > .title {
    position: absolute;
    top: 3.62rem;
    > p {
      font-weight: 500;
      line-height: 2.81rem;
      font-size: 1.99rem;
      color: #FFFFFF;
      text-align: center;
    }
    > p:nth-child(1) {
      line-height: 1.63rem;
      font-size: 1.25rem;
      color: rgba(255,255,255,0.65);
      margin-bottom: 0.91rem;
    }
    > p:nth-child(3) {
      /* 金色渐变：从浅金到深金 */
      background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
      /* 核心属性：将背景裁剪到文字区域 */
      background-clip: text;
      /* 文字透明，显示渐变背景 */
      color: transparent;
    }
  }

  > video {
    width: 100%;
  }
}

.repair-improve {
  margin: 0.63rem 1.45rem 0 1.45rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  > .title {
    position: absolute;
    margin-top: 3.26rem;
    > p {
      display: flex;
      justify-content: center;
      font-size: 1.99rem;
      line-height: 2.81rem;
      color: #fff;
      font-weight: 500;
    }
    > p:nth-child(1) {
      /* 金色渐变：从浅金到深金 */
      background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
      /* 核心属性：将背景裁剪到文字区域 */
      background-clip: text;
      /* 文字透明，显示渐变背景 */
      color: transparent;
    }
  }

  > img {
    width: 100%;
    object-fit: cover;
  }
}

.vagina-improve {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  > .title {
    position: absolute;
    margin-top: 3.62rem;
    > p {
      display: flex;
      justify-content: center;
      font-size: 1.99rem;
      line-height: 2.81rem;
      color: #fff;
      font-weight: 500;
    }
    > p:nth-child(1) {
      /* 金色渐变：从浅金到深金 */
      background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
      /* 核心属性：将背景裁剪到文字区域 */
      background-clip: text;
      /* 文字透明，显示渐变背景 */
      color: transparent;
    }
  }
  > .four-intravaginal-list {
    margin-top: 11.96rem;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: 1.09rem;
    > .intravaginal-item {
      padding: 0 1.54rem;
      display: flex;
      align-items: center;
      justify-content: center;
      > video {
        width: 100%;
        border-radius: 1.09rem 1.09rem 1.09rem 1.09rem;
      }
      > .title {
        position: absolute;
        font-size: 1.73rem;
        color: #FFFFFF;
        font-weight: 500;
      }
    }
  }
  > .swiper-copyright {
    bottom: 0;
    top: 1rem;
    height: 6rem;
  }
}

.vulva-repair, {
  position: relative;
  padding: 1rem 1.54rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  > video {
    height: 56.54rem;
    width: 100%;
    object-fit: cover;
    border-radius: 1.09rem 1.09rem 1.09rem 1.09rem;
  }
  > .img-copyright{
    position: relative;
    bottom: 0;
    top: 1rem;
    right: 1.2rem;
    height: 6rem;
  }
  > .title {
    position: absolute;
    margin-top: 2.72rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    > p {
      font-weight: 500;
      font-size: 1.99rem;
      height: 2.81rem;
      color: #fff;
    }
    > p:nth-child(1) {
      /* 金色渐变：从浅金到深金 */
      background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
      /* 核心属性：将背景裁剪到文字区域 */
      background-clip: text;
      /* 文字透明，显示渐变背景 */
      color: transparent;
    }
    > p:nth-child(3) {
      text-align: center;
      margin-top: 1.09rem;
      width: 18.57rem;
      height: 1.54rem;
      font-size: 1.09rem;
      color: rgba(255,255,255,0.65);
    }
  }
  > img {
    height: 6.83rem;
    position: absolute;
    top: 17.39rem;
  }
  > .img-copyright{
    left: 1.2rem;
  }
}

.soothing-massage {
  position: relative;
  padding: 1rem 1.54rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  > .video-container {
    display: flex;
    align-items: flex-start;
    z-index: 0;
    height: 56.54rem;
    border-radius: 1.15rem;
    overflow: hidden;
    > video {
      z-index: 1;
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  > .img-copyright{
    position: relative;
    bottom: 0;
    top: 1rem;
    right: 1.2rem;
    height: 6rem;
  }
  > .title {
    z-index: 2;
    position: absolute;
    margin-top: 2.72rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    > p {
      font-weight: 500;
      font-size: 1.99rem;
      height: 2.81rem;
      color: #fff;
    }
    > p:nth-child(1) {
      /* 金色渐变：从浅金到深金 */
      background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
      /* 核心属性：将背景裁剪到文字区域 */
      background-clip: text;
      /* 文字透明，显示渐变背景 */
      color: transparent;
    }
    > p:nth-child(3) {
      text-align: center;
      margin-top: 1.09rem;
      width: 18.57rem;
      height: 1.54rem;
      font-size: 1.09rem;
      color: rgba(255,255,255,0.65);
    }
  }
  > img {
    height: 6.83rem;
    position: absolute;
    top: 17.39rem;
  }
  > .img-copyright{
    left: 1.2rem;
  }
}

.diastasis-recti {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  > img {
    width: 100%;
    object-fit: cover;
  }

  > .about {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    > p {
      line-height: 2.81rem;
      font-size: 1.99rem;
      font-weight: 500;
      color: #fff;
    }

    > p:nth-child(1) {
      font-size: 1.25rem;
      line-height: 1.63rem;
      color: rgba(255,255,255,0.65);
      font-weight: 500;
      margin-bottom: 0.91rem;
      margin-top: 3.62rem;
    }

    > p:nth-child(3) {
      /* 金色渐变：从浅金到深金 */
      background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
      /* 核心属性：将背景裁剪到文字区域 */
      background-clip: text;
      /* 文字透明，显示渐变背景 */
      color: transparent;
    }
  }
}

.electrode-pad {
  position: relative;
  padding: 2.72rem 1.54rem 0 1.54rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  > img {
    width: 100%;
    object-fit: cover;
  }
  > .about {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 2.36rem;
    > p {
      font-weight: 500;
      line-height: 2.12rem;
      font-size: 1.54rem;
      color: #fff;
    }
    > p:nth-child(2) {
      line-height: 2.98rem;
      font-size: 2.12rem;
      /* 金色渐变：从浅金到深金 */
      background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
      /* 核心属性：将背景裁剪到文字区域 */
      background-clip: text;
      /* 文字透明，显示渐变背景 */
      color: transparent;
    }
    > p:nth-child(3), p:nth-child(4) {
      font-size: 1.09rem;
      line-height: 1.54rem;
      color: rgba(255,255,255,0.65);
    }
    > p:nth-child(3) {
      margin-top: 0.91rem;
    }
  }
  > .img-copyright{
    position: relative;
    bottom: 0;
    top: 1rem;
    right: 1.2rem;
    height: 6rem;
  }
}

.product-science {
  height: 52.1rem;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #100622;

  > #scienceSwiper {
    padding-top: 3.62rem;
    height: 100%;
    position: relative;
    overflow: hidden;

    .swiper-slide {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      > .img-container {
        padding: 0 1.54rem;
        > img {
          width: 100%;
        }
      }
      > .words {
        position: absolute;
        font-size: 0.8rem;
        color: rgba(255, 255, 255, 0.6);
        text-align: center;
        line-height: 0.9rem;
        bottom: 14.3rem;
        width: 80%;
      }
      > .title {
        position: absolute;
        width: 34.5rem;
        height: 9.3rem;
        bottom: 5rem;
        display: flex;
        justify-content: center;
        text-align: center;
        line-height: 2.02rem;
        font-size: 1.45rem;
        color: rgba(255,255,255,0.65);
        align-items: center;
        background: linear-gradient( 0deg, #3E2365 0%, #200F37 100%);
        border-radius: 0rem 0rem 1.09rem 1.09rem;
      }
    }

    .swiper-pagination {
      position: absolute;
      bottom: 1.81rem;
    }

    /deep/ .swiper-pagination-bullet {
      background: transparent;     /* 改成透明 = 空心 */
      border: 0.1rem solid #fff;    /* 白色边框 */
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #fff;             /* 选中 = 白色实心 */
      border: 0.1rem solid transparent;
    }
  }
}

.research {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  > img {
    width: 100%;
    object-fit: cover;
  }

  > .about {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    > p {
      line-height: 2.81rem;
      font-size: 1.99rem;
      font-weight: 500;
      color: #fff;
    }

    > p:nth-child(1) {
      margin-top: 6.62rem;
      /* 金色渐变：从浅金到深金 */
      background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
      /* 核心属性：将背景裁剪到文字区域 */
      background-clip: text;
      /* 文字透明，显示渐变背景 */
      color: transparent;
    }

    > p:nth-child(3) {
      font-size: 1.25rem;
      line-height: 1.63rem;
      color: rgba(255,255,255,0.65);
      font-weight: 500;
      margin-top: 0.91rem;
    }
  }
}

.zhuanli {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  > img {
    width: 100%;
    object-fit: cover;
  }

  > .about {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    > p {
      line-height: 2.81rem;
      font-size: 1.99rem;
      font-weight: 500;margin-top: 3.62rem;
      /* 金色渐变：从浅金到深金 */
      background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
      /* 核心属性：将背景裁剪到文字区域 */
      background-clip: text;
      /* 文字透明，显示渐变背景 */
      color: transparent;
    }
  }
}

.medical-zhuanli {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    > img {
      width: 100%;
      object-fit: cover;
    }

    > .about {
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      > p {
        line-height: 2.81rem;
        font-size: 1.99rem;
        font-weight: 500;
      }

      > p:nth-child(1) {
        margin-top: 3.62rem;
        /* 金色渐变：从浅金到深金 */
        background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
        /* 核心属性：将背景裁剪到文字区域 */
        background-clip: text;
        /* 文字透明，显示渐变背景 */
        color: transparent;
      }

      > p:nth-child(2) {
        font-size: 1.25rem;
        line-height: 1.63rem;
        color: rgba(255,255,255,0.65);
        font-weight: 500;
        margin-top: 0.91rem;
      }
    }
  }
</style>
